module.exports = __webpack_public_path__ + "static/media/layer7.e22b9475.svg";